<template>
  <div class="businessresource-listing-filter">
    <!-- Desktop Variant -->
    <div class="d-none d-lg-block">
      <div class="businessresource-listing-filter-count-wrap fw-bold mt-3 mb-2" aria-live="polite">
        <slot name="business-resource-filter-count-prefix"></slot>
        <span class="filter-count">{{ results ? results.length : '' }}</span>
        <slot name="business-resource-filter-count-suffix"></slot>
      </div>
      <button class="btn btn-link text-black w-100 text-start mb-3 border-0 fs-large fw-medium" data-bs-toggle="collapse" data-bs-target="#business-resource-filter-list" aria-expanded="true" aria-controls="business-resource-filter-list">
        <slot name="business-resource-filter-title"></slot>
      </button>
      <div class="collapse show" id="business-resource-filter-list">
        <template v-for="(group, groupIndex) in filterGroups">
          <div v-if="group.items.length > 0" class="my-3">
            <button
                    v-if="group.id != 'default'"
                    class="btn btn-link text-black w-100 text-start ps-0 mb-3 border-0"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#desktop-generic-filter-list-' + group.id"
                    aria-expanded="true"
                    :aria-controls="'desktop-generic-filter-list-' + group.id">
              {{ group.title }}
            </button>
            <div class="collapse show" :id="'desktop-generic-filter-list-' + group.id">
              <form :id="'desktop-generic-filter-form-' + group.id" :class="'hide-more-container' + (group.showMore?'':' hide-more-items')">
                <div v-for="(filter, index) in group.items" :class="'form-check' + (9 < index ? ' more-item' : '')">
                  <input :id="`desktop-generic-filter-${group.id}-${filter.value}`" 
                         class="form-check-input" 
                         type="checkbox" 
                         :value="filter.value" 
                         v-model="currentQuery.filters[group.id]" 
                         :disabled="showItemCount && filterCount(group.id, filter.value) == 0"/>
                  <label class="form-check-label text-uppercase" :for="`desktop-generic-filter-${group.id}-${filter.value}`">
                    <slot :name="`generic-filter-label-${group.id.toString().toLowerCase()}-${filter.value.toString().toLowerCase()}`">
                      <i class="fst-normal" v-html="filter.title"></i>
                    </slot>
                    <span v-if="showItemCount" class="ms-1">
                      <slot name="generic-filter-item-count-prefix"></slot>
                      <span class="filter-count">{{ filterCount(group.id, filter.value) }}</span>
                      <slot name="generic-filter-item-count-suffix"></slot>
                    </span>
                  </label>
                </div>
              </form>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- Mobile Variant -->
    <div class="d-block d-lg-none">
      <button 
        class="btn btn-link text-black px-0 my-3 bg-transparent" 
        data-bs-toggle="offcanvas" 
        data-bs-target="#business-resource-filter-list-mobile" 
        aria-expanded="true" 
        aria-controls="business-resource-filter-list-mobile"
      >
        <slot name="business-resource-filter-mobile-title"></slot>
      </button>
      <div class="offcanvas offcanvas-end w-100" tabindex="-1" id="business-resource-filter-list-mobile">
        <div class="offcanvas-header justify-content-end">
          <button type="button" class="btn-close mr-4" data-bs-dismiss="offcanvas" aria-label="Close">
            <slot name="offcanvas-close-button"></slot>
          </button>
        </div>
        <div class="offcanvas-body">
          <div class="offcanvas-panel-title">
            <strong class="h3">
              <slot name="business-resource-filter-offcanvas-title"></slot>
            </strong>
          </div>
          <div class="offcanvas-panel-body pb-0">
            <div class="businessresource-listing-filter-count-wrap fw-bold fs-eyebrow" aria-live="polite">
              <slot name="business-resource-filter-count-prefix"></slot>
              <span class="filter-count">{{ results ? results.length : '' }}</span>
              <slot name="business-resource-filter-count-suffix"></slot>
            </div>
            <div class="text-uppercase my-3 fs-large fw-medium">
              <slot name="business-resource-filter-title"></slot>
            </div>
            <div v-for="(group, groupIndex) in filterGroups">
              <button v-if="group.id != 'default'" 
                      class="btn btn-link text-black w-100 text-start my-3 border-0" 
                      data-bs-toggle="collapse" 
                      :data-bs-target="'#mobile-generic-filter-list-' + group.id" 
                      aria-expanded="true" 
                      :aria-controls="'mobile-generic-filter-list-' + group.id">
                {{ group.title }}
              </button>
              <div class="collapse show" :id="'mobile-generic-filter-list-' + group.id">
                <form :id="'mobile-generic-filter-form-' + group.id" :class="'hide-more-container' + (group.showMore?'':' hide-more-items')">
                  <div v-for="(filter, index) in group.items" :class="'form-check' + (9 < index ? ' more-item' : '')">
                    <input :id="`mobile-generic-filter-${group.id}-${filter.value}`" 
                           class="form-check-input" 
                           type="checkbox" 
                           :value="filter.value" 
                           v-model="currentQuery.filters[group.id]" 
                           :disabled="showItemCount && filterCount(group.id, filter.value) == 0"/>
                    <label class="form-check-label text-uppercase" :for="`mobile-generic-filter-${group.id}-${filter.value}`">
                      <slot :name="`generic-filter-label-${group.id.toString().toLowerCase()}-${filter.value.toString().toLowerCase()}`">
                        <i class="fst-normal" v-html="filter.title"></i>
                      </slot>
                      <span v-if="showItemCount" class="ms-1">
                        <slot name="generic-filter-item-count-prefix"></slot>
                        <span class="filter-count">{{ filterCount(group.id, filter.value) }}</span>
                        <slot name="generic-filter-item-count-suffix"></slot>
                      </span>
                    </label>
                  </div>                 
                </form>
              </div>
            </div>
            <div class="offcanvas-panel-footer">
              <button class="btn btn-primary w-100" data-bs-dismiss="offcanvas" aria-label="Close">
                <slot name="business-resource-filter-apply"></slot>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['filterGroups', 'results', 'currentQuery', 'showCount', 'showItemCount'],
    methods: {
      filterCount(groupId, value) {
        // grab a deep copy for safe modification
        let query = JSON.parse(JSON.stringify(this.currentQuery));
        query.filters[groupId] = [value]; 
        return this.$parent.filterByQuery(query).length
      }
    }
  }
</script>
